import { render, staticRenderFns } from "./AccountRecharge.vue?vue&type=template&id=5bc60c0c&scoped=true"
import script from "./AccountRecharge.vue?vue&type=script&lang=ts"
export * from "./AccountRecharge.vue?vue&type=script&lang=ts"
import style0 from "./AccountRecharge.vue?vue&type=style&index=0&id=5bc60c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc60c0c",
  null
  
)

export default component.exports